import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'What is Openclaw for sales?',
  answer: 'Openclaw for sales is a feature within Openmart that acts as an AI sales agent to automate the manual work of prospecting. Instead of using complex filters to search a database, you give the agent a natural language prompt (e.g., "Find me highly-rated plumbers in Texas"). The agent queries Openmart\'s 200M+ local business database, scores the leads, and even drafts personalized outreach emails for you.'
}, {
  question: 'How does the agent get its data?',
  answer: "It is natively integrated with Openmart's proprietary database of over 200 million local businesses. This means it has real-time access to accurate firmographic data, reviews, tech stacks, and verified owner contact information."
}, {
  question: 'Can the agent write emails for me?',
  answer: 'Yes. Once the agent identifies and scores your ideal leads, it can automatically draft personalized outreach emails. It uses the specific data points it found (like a recent review or their specific location) to make the emails highly relevant.'
}, {
  question: 'Do I need to pay for this feature separately?',
  answer: 'No, it is included with your Openmart account. You only pay standard credits for the verified contact information (emails and phone numbers) that the agent retrieves for you.'
}, {
  question: 'Does it integrate with my CRM?',
  answer: 'Yes. The lists and sequences generated by the agent can be pushed directly to Salesforce, HubSpot, or exported as CSV files for use in any other tool.'
}, {
  question: 'How accurate is the AI scoring?',
  answer: 'The scoring is highly accurate because it\'s based on hard data from the Openmart database, not just AI guessing. You define the criteria (e.g., "prioritize businesses with low reviews"), and the agent strictly applies that logic to the dataset.'
}];
export function OpenclawFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-5421">
      <div className="bg-white rounded-[2.5rem] shadow-sm border border-slate-100 p-8 md:p-16 relative overflow-hidden" data-id="element-5422">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-5423">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 tracking-tight" data-id="element-5424">
            Frequently asked <span className="text-blue-600" data-id="element-5425">questions</span>
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-3" data-id="element-5426">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className={`relative rounded-2xl border transition-all duration-300 overflow-hidden group ${isOpen ? 'bg-blue-50/30 border-blue-200 shadow-md shadow-blue-600/5' : 'bg-white border-slate-200 hover:border-blue-200'}`} data-id="element-5427">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="relative z-10 w-full text-left flex justify-between items-center p-5 focus:outline-none" data-id="element-5428">
                  <span className={`font-bold transition-colors pr-8 ${isOpen ? 'text-blue-600' : 'text-slate-900 group-hover:text-blue-600'}`} data-id="element-5429">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.3
              }} className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 ml-4 transition-colors ${isOpen ? 'bg-blue-100 text-blue-600' : 'bg-slate-50 text-slate-400 group-hover:bg-blue-50 group-hover:text-blue-600'}`} data-id="element-5430">
                    <ChevronDownIcon className="w-4 h-4" data-id="element-5431" />
                  </motion.div>
                </button>
                <AnimatePresence data-id="element-5432">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden relative z-10" data-id="element-5433">
                      <div className="px-5 pb-5 pt-0 text-slate-500 leading-relaxed text-[15px]" dangerouslySetInnerHTML={{
                  __html: faq.answer
                }} data-id="element-5434" />
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}